import { render, staticRenderFns } from "./Bouncer.vue?vue&type=template&id=2dd64332&scoped=true"
import script from "./Bouncer.vue?vue&type=script&lang=js"
export * from "./Bouncer.vue?vue&type=script&lang=js"
import style0 from "./Bouncer.vue?vue&type=style&index=0&id=2dd64332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd64332",
  null
  
)

export default component.exports